// extracted by mini-css-extract-plugin
export var content = "_6z-3";
export var list = "_6z-4";
export var settingsContent = "_6z-7";
export var settingsPanel = "_6z-8";
export var state = "_6z-6";
export var triggerBadge = "_6z-2";
export var triggerButton = "_6z-1";
export var triggerShell = "_6z-0";
export var unreadDot = "_6z-5";